import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const PropertyDetailsSkeleton = () => {
  return (
    <div className="max-w-[1287px] mx-auto">
      <div className="h-[475px] w-full p-6 flex items-start gap-3">
        <div className="h-full w-[60%] rounded-tl-[12px] rounded-bl-[12px] overflow-hidden">
          <Skeleton height="100%" width="100%" borderRadius={0} />
        </div>
        <div className="grid grid-cols-2 grid-rows-2 items-center gap-3 w-[40%] h-full">
          {Array.from({ length: 4 }).map((_, index) => (
            <div
              key={index}
              className={`w-full h-full overflow-hidden ${
                index === 1 ? "rounded-tr-[12px]" : ""
              } ${index === 3 ? "rounded-br-[12px]" : ""}`}
            >
              <Skeleton height="100%" width="100%" borderRadius={0} />
            </div>
          ))}
        </div>
      </div>
      <div className="px-6 flex flex-col gap-y-2">
        <Skeleton height={30} width="15%" />
        <Skeleton height={30} width="40%" />
        <Skeleton height={40} width="60%" />
      </div>
    </div>
  );
};

export default PropertyDetailsSkeleton;
